<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
    			    <el-input placeholder="分拣单号" v-model="query.key" clearable  @change="query.ischange=true"></el-input>
    		  </el-form-item>
          <el-form-item>
    			    <el-button type="primary" size="small" icon="el-icon-search" round @click="getsortingorders">搜索</el-button>
    		  </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
	    	  <el-table ref="multipleTable" :data="sortorders"  style="width: 100%" v-loading="query.loading">
              <el-table-column label="ID" prop="id" align="left" width="100" />
              <el-table-column label="分拣单号" align="left">
                  <template slot-scope="scope">
                      <span>{{scope.row.documents}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="出库单数汇总" align="center" width="150">
                  <template slot-scope="scope">
                      <span>{{scope.row.orders}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="商品总数汇总" align="center" width="150">
                  <template slot-scope="scope">
                      <span>{{scope.row.goods}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="生成时间" align="center" width="170">
                  <template slot-scope="scope">
                      <span>{{scope.row.inputtime}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="270">
                  <template slot-scope="scope">
                      <!-- <el-button type="primary" size="small" round @click="showlogistics(scope.row)">打印电子面单</el-button> -->
                      <el-button type="warning" size="small" round @click="showcatgoods(scope.row)">打印拣货汇总单</el-button>
                  </template>
              </el-table-column>
	      	</el-table>
	      	<div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="query.rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
      	</div>

        
        <!-- 显示分拣提货汇总单 -->
        <el-dialog title="查看打印分拣单" :visible.sync="showcatchordergoodsDialog" width="70%" top="5vh">
            <div style="width:100%;text-align:left">
  	  				  每页展示  <input type="text" v-model="catchgoodsquery.rollpage" size="small" round  v-on:blur="changepage()"  style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px"/>  条
  	  			</div>	
            <div style="text-align:right;margin-bottom:10px">
                <el-button size="small" round @click="showcatchordergoodsDialog=false">取 消</el-button>
                <el-button type="primary" size="small" round @click="printsorts">打 印</el-button>
            </div>

            <!-- 销售出库单列表 -->
            <div class="print-sell-documents">
                <el-checkbox-group v-model="checksellids" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(item,index) in catsells" :label="item.sellid" :key="index">{{item.documents}}</el-checkbox>
                </el-checkbox-group>
                <div style="margin: 10px 0;"></div>
            </div>

            <!-- 汇总商品信息 -->
            <div id="printContent" v-loading="catchgoodsquery.loading" style="overflow:hidden">
                <div v-for="(item,i) in catgoodslists" :key="i">
                    <div class="print-sell-page-catstat" style="text-align:center;margin:10px 0;font-size:15px;font-weight:550">捡货单</div>
                    <div class="print-sell-page-catstat">
                        <span>销售单数量：{{catstats.orders}}</span>
                        <span>sku数量：{{catstats.goods}}</span>
                        <span>商品数量汇总：{{catstats.nums}}</span>
                        <span>时间：{{catstats.time}}</span>
                        <span style="float:right">{{item.page}}</span>
                    </div>
                    <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" class="print-sell-page-table">
                        <tr class="contactcontent print-sort-order">
                            <TD><DIV align=left><b>品牌</b></DIV></TD>
                            <TD><DIV align=left><b>品名</b></DIV></TD>
                            <TD><DIV align=left><b>规格</b></DIV></TD>
                            <TD><DIV align=left><b>编号</b></DIV></TD>
                            <TD><DIV align=left><b>汇总数量</b></DIV></TD>
                            <TD><DIV align=left><b>单位</b></DIV></TD>
                        </tr>
                        <tr v-for="(item,index) in item.goods" :key="index"  class="contactcontent print-sort-order">
                            <TD v-text="item.agentbrandname" align="left"></TD>
                            <TD v-text="item.productname" align="left"></TD>
                            <TD v-text="item.spec" align="left"></TD>
                            <TD v-text="item.number" align="left"></TD>
                            <TD v-text="item.nums" align="left"></TD>
                            <TD v-text="item.unit" align="left"></TD>
                        </tr> 
                    </TABLE>
                    <div class="pageBreak"></div>
          			</div>    
	  		</div>

            <div style="text-align:right;margin-top:30px">
                <el-button size="small" round @click="showcatchordergoodsDialog=false">取 消</el-button>
                <el-button type="primary" size="small" round @click="printsorts">打 印</el-button>
            </div>
        </el-dialog>


        <!-- 打印电子面单 -->
        <logisticsprint v-model="sortorderid" @close="closesell" />


  </div>
  </transition>
</template>

<script>
import logisticsprint from '@/components/home/print/logisticsprint' //电子面单信息
export default {
  props:['childdata'],
  components: {logisticsprint},
  data () {
    return {
      url:this.GLOBAL.domain+"Sellshippingbirld/index",
      transitionshow:true,
      actionauth:[],
      query: {
        act:'getsortinglists',
        token:this.$cookies.get('token'),
        key:'',
        loading:false,
        ischange:false,
        p:1,
        rollpage:10,
        rows:0
      },
      sortorders:[],

      showcatchordergoodsDialog:false,
      catchgoodsquery: {
          act:'getsortorders',
          token:this.$cookies.get('token'),
          id:'',
          sellids:'',
          loading:false,
          rollpage:100,
      },
      catgoodslists:[],
      catstats:{},
      catsells:[],
      checksellids:[],
      rollpage:100,
      sortorderid:'',


    }  
  },

  
  mounted(){
      this.getsortingorders(); //获取二次分拣单信息

      //点击带参数跳转，精确定位展示打印单个出库单
      if(this.childdata.sortorderid > 0) this.sortorderid=this.childdata.sortorderid;
  },

  watch: {
    childdata(val) {
        if(val.sortorderid) { //打开销售单的电子面单打印列表
            this.sortorderid=val.sortorderid;
            this.getsortingorders();
        }
    }
  },
  
  methods:{

      //显示电子面单
      showlogistics(item) {
          this.sortorderid=item.id;
      },

      //关闭显示电子面单窗口
      closesell() {
          this.sortorderid='';
      },



      //打印分拣订单
      printsorts() {
          //设置打印完成后回调页面
          this.$cookies.set('returnurlids','sellprint');
          //获取打印信息
          var div_print=document.getElementById('printContent'); 
          var newStr=div_print.innerHTML;
          document.body.innerHTML=newStr;
          window.print();	    
          location.reload();
      },


      ////////////////////////////////////////////////////////////////////////////////


      //获取打印汇总单
      showcatgoods(item) {
         this.catchgoodsquery.id=item.id;
         this.showcatchordergoodsDialog=true; 
         this.checksellids=[];
         
         this.getmysorordersells(item.id);  //获取分拣单订单列表
         this.getmysortordergoods(); //获取分拣单数据信息
      },

      //获取分拣单订单列表
      getmysorordersells(id) {
          var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
          resource.save({act:'getsortsells',token:this.$cookies.get('token'),id:id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.catsells=JSON.parse(Base64.decode(res.data.Data));
                  var _this=this;
                  this.catsells.forEach(function(e,i) {
                      _this.checksellids.push(e.sellid);
                  });
              }
          }).catch((res) => {
                
          });	
      },

      //勾选 / 取消勾选订单
      handleCheckedCitiesChange() {
          if(this.checksellids.length==0) this.catchgoodsquery.sellids='a0';
          if(this.checksellids.length > 0) this.catchgoodsquery.sellids=this.checksellids.join(",");
          this.getmysortordergoods();
      },


      //获取分拣单数据信息
      getmysortordergoods() {
          this.catchgoodsquery.rollpage > 0 ? '' : this.catchgoodsquery.rollpage=100;
          this.catchgoodsquery.loading=true;
          var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
          resource.save(this.catchgoodsquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.catchgoodsquery.loading=false;
              }else{
                  var result=JSON.parse(Base64.decode(res.data.Data));
                  this.catgoodslists=result.lists;
                  this.catstats=result.stats;
                  this.catchgoodsquery.loading=false;
              }
          }).catch((res) => {
                this.catchgoodsquery.loading=false;
          });	
      },

      //修改每页条数
      changepage() {
          this.getmysortordergoods();
      },

      ////////////////////////////////////////////////////////////////////////////////////////////////
      

      //获取二次分拣单信息列表
      getsortingorders() {
          if(this.query.ischange) {
              this.query.p=1;
              this.query.rollpage=10;
          }

          this.query.loading=true;
          var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
          resource.save(this.query).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
              }else{
                this.sortorders=JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
                if(this.query.ischange) this.query.ischange=false;
              }
          }).catch((res) => {
              this.query.loading=false;
          });	
      },

      orderPageSizeChange(val) {
          this.query.rollpage = val;
          this.getsortingorders();
      },
      orderPageCurrentChange(val) {
          this.query.p = val;
          this.getsortingorders();
      },


      
  }

}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.print-sell-page-table {border-collapse:collapse;font-size:13px;border-color:#333333}
.contactcontent td {line-height:21px;}
.print-sort-order td {padding:5px 0 5px 5px;}
.print-sell-page-catstat {display:inline-block;width:100%;font-size:13px;margin-bottom:10px}
.print-sell-page-catstat span {margin-right:5%;}
</style>


// WEBPACK FOOTER //
// src/components/home/print/sellprint.vue